<template>
  <TopbarSpeedDial :buttons="buttons" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'ServiceApiKeySpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'New Service Api Key',
          icon: 'add',
          colorClass: 'primary',
          to: 'new',
        },
      ],
    }
  },
  computed: {
    buttons: function() {
      return this.buttonsConfig
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/service_api_keys/ServiceApiKeySpeedDial.vue